import React, { useEffect, useState } from 'react'
import { Layout, Spin, notification } from 'antd'
import clsx from 'clsx'
import { get, has, omit, find, isEmpty } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PictureWall from './PictureWall'
import { router } from '../../../system/routing'
import { withTranslation } from 'react-i18next'
import apiService from '../apiService'
import { getVar } from '../../../system/support/helpers'

const UploadProductDamageImages = ({ location, t }) => {
    const [productIssueInfo, setProductIssueInfo] = useState({})
    const [loading, setLoading] = useState(false)
    useEffect(async () => {
        const locationQuery = router.getLocationQuery()
        const queryString = new URLSearchParams(omit(locationQuery, 'auth_token')).toString()
        router.replace(`${location.pathname}?${queryString}`)
        await fetchPackageItems(locationQuery)
    }, [])

    async function fetchPackageItems(params) {
        const { id_package_item, id_package_item_issue, package_id } = params
        try {
            setLoading(true)
            const response = await apiService.getPackageProducts(package_id)

            if (has(response, 'data.code.order_not_found')) {
                return notification.error({
                    message: t('package:checking.message_order_not_found'),
                })
            }
            const packageItems = getVar(response, 'data.package_items', [])
            const packageItem = packageItems.find(item => item.package_item.id == id_package_item)
            const issues = getVar(packageItem, 'package_item_issues', [])
            const productIssueInfo = issues.find(issue => issue.id == id_package_item_issue)
            setProductIssueInfo(productIssueInfo)
            if (isEmpty(productIssueInfo)) {
                notification.error({
                    message: t('package:checking.message_cant_load_products'),
                })
            }
            setLoading(false)
        } catch (e) {
            notification.error({
                message: t('package:checking.message_cant_load_products'),
            })

            setLoading(false)
        }
    }

    return (
        <Layout className={clsx('upload-damaged-images')}>
            <Spin spinning={loading}>
                <PerfectScrollbar
                    options={{
                        wheelPropagation: false,
                    }}>
                    {!isEmpty(productIssueInfo) && (
                        <PictureWall
                            productIssueInfo={productIssueInfo}
                            sorted
                        />
                    )}
                </PerfectScrollbar>
            </Spin>
        </Layout>
    )
}

export default withTranslation()(UploadProductDamageImages)
